
import { Users, TrendingUp, TriangleAlert, XCircle } from "lucide-react";
import { formatCountWithArabicNumbers, formatPercentageWithArabicNumbers } from "@/utils/arabicNumbers";

interface UnifiedStatsCardProps {
  totalStudents: number;
  attendanceRate: number;
  alertsCount: number;
  absencePercentage: number;
}

export const UnifiedStatsCard = ({
  totalStudents,
  attendanceRate,
  alertsCount,
  absencePercentage,
}: UnifiedStatsCardProps) => {
  return (
    <div className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* إجمالي الطلاب */}
        <div className="flex items-center justify-between p-3 bg-gradient-to-r from-transparent via-brand-green/10 to-transparent rounded-xl border-l-4 border-brand-green border border-brand-green/20 shadow-sm hover:shadow-md transition-shadow backdrop-blur-sm">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-brand-green/10 rounded-full flex items-center justify-center">
                <Users className="h-4 w-4 text-brand-green" />
              </div>
            </div>
            <div className="text-xs font-medium text-brand-green">إجمالي الطلاب</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-lg font-bold text-brand-green">{formatCountWithArabicNumbers(totalStudents)}</div>
            <div className="text-xs text-brand-green">طالب</div>
          </div>
        </div>

        {/* معدل الحضور */}
        <div className="flex items-center justify-between p-3 bg-gradient-to-r from-transparent via-brand-teal/10 to-transparent rounded-xl border-l-4 border-brand-teal border border-brand-teal/20 shadow-sm hover:shadow-md transition-shadow backdrop-blur-sm">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-brand-teal/10 rounded-full flex items-center justify-center">
                <TrendingUp className="h-4 w-4 text-brand-teal" />
              </div>
            </div>
            <div className="text-xs font-medium text-brand-teal">معدل الحضور</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-lg font-bold text-brand-teal">{formatPercentageWithArabicNumbers(attendanceRate)}</div>
          </div>
        </div>

        {/* معدل الغياب */}
        <div className="flex items-center justify-between p-3 bg-gradient-to-r from-transparent via-brand-gray/10 to-transparent rounded-xl border-l-4 border-brand-gray border border-brand-gray/20 shadow-sm hover:shadow-md transition-shadow backdrop-blur-sm">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-brand-gray/10 rounded-full flex items-center justify-center">
                <XCircle className="h-4 w-4 text-brand-gray" />
              </div>
            </div>
            <div className="text-xs font-medium text-brand-gray">معدل الغياب</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-lg font-bold text-brand-gray">{formatPercentageWithArabicNumbers(absencePercentage)}</div>
          </div>
        </div>

        {/* تنبيهات الغياب */}
        <div className="flex items-center justify-between p-3 bg-gradient-to-r from-transparent via-brand-red/10 to-transparent rounded-xl border-l-4 border-brand-red border border-brand-red/20 shadow-sm hover:shadow-md transition-shadow backdrop-blur-sm">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-brand-red/10 rounded-full flex items-center justify-center">
                <TriangleAlert className="h-4 w-4 text-brand-red" />
              </div>
            </div>
            <div className="text-xs font-medium text-brand-red">تنبيهات الغياب</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-lg font-bold text-brand-red">{formatCountWithArabicNumbers(alertsCount)}</div>
            <div className="text-xs text-brand-red">تنبيه</div>
          </div>
        </div>
      </div>
    </div>
  );
};
